/* eslint-disable react/require-default-props */
import React from 'react';
export function ModalBody({ children, className = '' }) {
    const bodyClasses = ['qmb-ui-modal-body', className].filter(Boolean).join(' ');
    return React.createElement("div", { className: bodyClasses }, children);
}
